import React, { useState, useEffect } from "react";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import Paper from "@mui/material/Paper";
import { Input } from "antd";
import { connect } from "react-redux";
import { PrimaryButton, Notify } from "../../../../components";
import Loader from "../../../slidebox/components/SlideTable/Loader";
import {
  getAllWorkgroupAction,
  addWorkgroupAction,
  editWorkgroupAction,
  deleteWorkgroupAction,
  editWorkgroupMembersAction,
} from "../../actions/adminDashboard-action";
import EditIcon from "../../../../assets/icons/EditRoleIcon.svg";
import { SingleSelect } from "../../../../components";
import cancelIcon from "../../../../assets/icons/close-new.svg";
import { Tooltip } from "react-tooltip";

const WorkgroupTable = ({
  showLoader,
  isPopUpOpen,
  userList,
  loggedUserEmail,
  loggedUserRoleId,
  blink,
  setBlink,
  workgroupData,
  getWorkgroupData,
  addWorkgroup,
  editWorkgroupNameFn,
  deleteWorkgroup,
  editWorkgroupMembersFn,
  ...rest
}) => {
  const [selectedRowIndex, setSelectedRowIndex] = useState("");
  const [showCloseIcon, setShowCloseIcon] = useState([]);
  const [workgroupName, setWorkgroupName] = useState("");
  const [workgroupMembers, setWorkgroupMembers] = useState([]);
  const [workgroupEdit, setWorkgroupEdit] = useState([]);
  const [addNewWorkgroup, setAddWorkgroup] = useState(false);
  const [editWorkgroupName, setEditWorkgroupName] = useState([]);
  const [userLength, setUserLength] = useState(3);
  const [editWorkgroupMembers, setWorkgroupEditMembers] = useState([]);
  const [editMemberList, setEditMemberList] = useState([]);

  const memberList = userList.map((user) => {
    return {
      value: user.userID,
      label: user.firstName + " " + user.lastName,
    };
  });

  const handleAddNewWorkgroup = () => {
    setAddWorkgroup(true);
    setWorkgroupName("");
  };

  const handleSubmitAddWorkgroup = () => {
    if (workgroupName === "") {
      Notify({ value: "Workgroup name is required" });
      return;
    }
    addWorkgroup({
      workgroupName,
      addWorkgroupName: true,
      workgroupUsers: workgroupMembers.map((member) => member.value),
    });
    setAddWorkgroup(false);
  };

  const handleSubmitEditWorkgroup = (event, workgroupId) => {
    if (event && event.key && event.key !== "Enter") return;
    if (Object.values(editWorkgroupName)[0] === "") {
      Notify({ value: "Workgroup name is required" });
      return;
    }
    editWorkgroupNameFn({
      workgroupId,
      workgroupName: Object.values(editWorkgroupName)[0],
    });
    setAddWorkgroup(false);
    setWorkgroupEdit([]);
    setShowCloseIcon([]);
    setEditWorkgroupName([]);
  };

  const handleWorkgroupEdit = (index) => {
    setWorkgroupEdit({ [index]: true });
    setShowCloseIcon({ [index]: true });
  };

  const handleSelectChange = (selectedOption) => {
    console.log(selectedOption);
    setWorkgroupMembers(selectedOption);
  };

  const handleAddOrRemoveUsers = (selectedOption) => {
    setEditMemberList(selectedOption);
  };

  const handleDeleteWorkgroup = (workgroupData) => {
    deleteWorkgroup({
      workgroupId: workgroupData.workgroupId,
      workgroupName: workgroupData.workgroupName,
    });
  };

  const handleEditWorkgroupMembers = (index, currentMembers) => {
    setWorkgroupEditMembers({ [index]: true });
    setEditMemberList(
      currentMembers.map((m) => ({
        value: m.userId,
        label: m.firstName + " " + m.lastName,
      }))
    );
  };

  const handleSubmitEditWorkgroupMembers = (workgroupData, index) => {
    editWorkgroupMembersFn({
      workgroupId: workgroupData.workgroupId,
      workgroupUsers: editMemberList.map((member) => member.value),
    });
    setWorkgroupEditMembers({ [index]: false });
  };

  useEffect(() => {
    !isPopUpOpen && setSelectedRowIndex("");
  }, [isPopUpOpen]);

  useEffect(() => {
    getWorkgroupData();
  }, []);

  return showLoader ? (
    <Loader />
  ) : (
    <div className="workgroup-container">
      <div className="buttons-container">
        <PrimaryButton
          label="Add Workgroup"
          onClick={() => handleAddNewWorkgroup()}
          extraClass="add-workgroup"
        />
      </div>
      <div className="workgroup-list-container">
        <TableContainer
          className="table-scroll"
          elevation={0}
          component={Paper}
          sx={{ height: "55vh !important" }}
        >
          <Table className="workgroup-table" aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell align="left" className="table-heading">
                  <span className="workgroup-list-name">Workgroup Name</span>
                </TableCell>
                <TableCell align="left">Members</TableCell>
                <TableCell align="left">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody className={blink ? "blink-user-list-table" : ""}>
              {workgroupData &&
                workgroupData.map((workgroup, index) => {
                  return (
                    <TableRow key={index}>
                      <TableCell
                        align="left"
                        className="workgroup-capitalize workgroup-name"
                        style={{ width: "25%" }}
                      >
                        {!workgroupEdit[index] && workgroup.workgroupName}

                        {workgroupEdit[index] && showCloseIcon[index] && (
                          <Input
                            className="workgroup-name-value"
                            defaultValue={workgroup.workgroupName}
                            value={editWorkgroupName[index]}
                            onChange={(e) =>
                              setEditWorkgroupName({ [index]: e.target.value })
                            }
                            onKeyDown={(e) =>
                              handleSubmitEditWorkgroup(e, workgroup.workgroupId)
                            }
                          />
                        )}

                        {workgroupEdit[index] &&
                          showCloseIcon[index] &&
                          editWorkgroupName[index] !== undefined &&
                          editWorkgroupName[index] !== "" &&
                          editWorkgroupName[index] !== workgroup.workgroupName && (
                            <svg
                              width="14"
                              height="14"
                              viewBox="0 0 14 14"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              style={{ cursor: "pointer", marginLeft: "4px" }}
                              onClick={() =>
                                handleSubmitEditWorkgroup(null, workgroup.workgroupId)
                              }
                            >
                              <path
                                d="M2 7L5.5 10.5L12 3.5"
                                stroke="#0F0DA1"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          )}

                        {showCloseIcon[index] && (
                          <span
                            onClick={() => {
                              setShowCloseIcon({ [index]: false });
                              setWorkgroupEdit({ [index]: false });
                            }}
                          >
                            <img
                              width="12px"
                              height="12px"
                              src={cancelIcon}
                              className="close-icon"
                              alt="Cancel"
                            />
                          </span>
                        )}

                        {(!showCloseIcon[index] ||
                          showCloseIcon.length === 0) &&
                          workgroup.workgroupName !== "Default Workgroup" && (
                            <img
                              width="12px"
                              height="12px"
                              src={EditIcon}
                              className="edit-workgroup-icon"
                              onClick={() => handleWorkgroupEdit(index)}
                              alt="Edit"
                            />
                          )}
                      </TableCell>
                      <TableCell align="left" style={{ width: "60%" }}>
                        <div>
                          {!editWorkgroupMembers[index] &&
                            workgroup.userList
                              .slice(0, userLength)
                              .map((user, index) => (
                                <span key={index} className="member-name">
                                  {user.firstName + " " + user.lastName}
                                </span>
                              ))}
                          <span
                            className="user-count"
                            data-for="workgroup-tooltip"
                            data-tip={workgroup.userList
                              .slice(userLength, workgroup.userList.length)
                              .map(
                                (user) => user.firstName + " " + user.lastName
                              )}
                          >
                            {!editWorkgroupMembers[index] &&
                            workgroup.userList.length > userLength
                              ? workgroup.userList.length - userLength +
                                " " +
                                "more"
                              : ""}
                          </span>
                          {editWorkgroupMembers[index] && (
                            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                              <div style={{ width: "80%" }}>
                                <SingleSelect
                                  options={[]}
                                  handleChange={handleAddOrRemoveUsers}
                                  placeholder="Enter User Name"
                                  customStyles={true}
                                  style={{ backgroundColor: "white" }}
                                  type={"user-list"}
                                  members={memberList}
                                  value={editMemberList}
                                />
                              </div>
                              <svg
                                width="14"
                                height="14"
                                viewBox="0 0 14 14"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                style={{ cursor: "pointer", flexShrink: 0 }}
                                onClick={() =>
                                  handleSubmitEditWorkgroupMembers(workgroup, index)
                                }
                              >
                                <path
                                  d="M2 7L5.5 10.5L12 3.5"
                                  stroke="#0F0DA1"
                                  strokeWidth="2"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                              <span
                                style={{ cursor: "pointer", flexShrink: 0 }}
                                onClick={() =>
                                  setWorkgroupEditMembers({ [index]: false })
                                }
                              >
                                <img
                                  width="12px"
                                  height="12px"
                                  src={cancelIcon}
                                  className="close-icon"
                                  alt="Cancel"
                                />
                              </span>
                            </div>
                          )}
                          {!editWorkgroupMembers[index] &&
                            workgroup.workgroupName !== "Default Workgroup" && (
                              <img
                                width="12px"
                                height="12px"
                                src={EditIcon}
                                className="edit-workgroup-icon"
                                onClick={() =>
                                  handleEditWorkgroupMembers(index, workgroup.userList)
                                }
                                alt="Edit members"
                              />
                            )}
                        </div>
                      </TableCell>
                      <TableCell
                        align="left"
                        className="workgroup-action"
                        onClick={() => handleDeleteWorkgroup(workgroup)}
                      >
                        {workgroup.workgroupName !== "Default Workgroup"
                          ? "Delete"
                          : ""}
                      </TableCell>
                    </TableRow>
                  );
                })}
              {addNewWorkgroup && (
                <TableRow>
                  <TableCell
                    align="left"
                    className="workgroup-capitalize workgroup-name"
                    style={{ width: "25%" }}
                  >
                    <Input
                      className="workgroup-name-value"
                      value={workgroupName}
                      onChange={(e) => setWorkgroupName(e.target.value)}
                      placeholder="Enter Workgroup Name"
                      autoFocus
                    />
                    {workgroupName !== "" && (
                      <svg
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{ cursor: "pointer", marginLeft: "4px" }}
                        onClick={handleSubmitAddWorkgroup}
                      >
                        <path
                          d="M2 7L5.5 10.5L12 3.5"
                          stroke="#0F0DA1"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    )}
                    <span
                      style={{ cursor: "pointer" }}
                      onClick={() => setAddWorkgroup(false)}
                    >
                      <img
                        width="12px"
                        height="12px"
                        src={cancelIcon}
                        className="close-icon"
                        alt="Cancel"
                      />
                    </span>
                  </TableCell>
                  <TableCell
                    align="left"
                    className="workgroup-capitalize workgroup-name"
                  >
                    <SingleSelect
                      options={[]}
                      handleChange={handleSelectChange}
                      placeholder="Enter User Name"
                      customStyles={true}
                      style={{ width: "100%", backgroundColor: "white" }}
                      type={"user-list"}
                      members={memberList}
                      classname="workgroup-users"
                    />
                  </TableCell>
                  <TableCell />
                </TableRow>
              )}
            </TableBody>
          </Table>
          <Tooltip
            id="workgroup-tooltip"
            place="top"
            type="dark"
            effect="solid"
          />
        </TableContainer>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  ...state.Dashboard,
  workgroupData: state.Dashboard.workgroupData,
});

const mapDispatchToProps = (dispatch) => ({
  getWorkgroupData: () => dispatch(getAllWorkgroupAction()),
  addWorkgroup: (payload) => dispatch(addWorkgroupAction(payload)),
  editWorkgroupNameFn: (payload) => dispatch(editWorkgroupAction(payload)),
  editWorkgroupMembersFn: (payload) =>
    dispatch(editWorkgroupMembersAction(payload)),
  deleteWorkgroup: (payload) => dispatch(deleteWorkgroupAction(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(WorkgroupTable);